module.exports = __webpack_public_path__ + "media/post-listing-block-3-overlay.fedbbee3.png";